import { useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { allauthErrorMessage, useVerifyEmail } from "@/lib/auth";

export default function VerifyEmailPage() {
  const { key = "" } = useParams();
  const verify = useVerifyEmail();
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current || !key) return;
    attempted.current = true;
    verify.mutate(key);
  }, [key, verify]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Verify your email</CardTitle>
          <CardDescription>Confirming your email address…</CardDescription>
        </CardHeader>
        <CardContent>
          {verify.isSuccess ? (
            <p className="rounded-md bg-success/10 p-3 text-sm text-success">
              Your email has been verified.{" "}
              <Link to="/login" className="font-medium underline">
                Sign in
              </Link>{" "}
              to get started.
            </p>
          ) : verify.isError ? (
            <p className="rounded-md bg-destructive/10 p-3 text-sm text-destructive">
              {allauthErrorMessage(
                verify.error,
                "This verification link is invalid or has expired."
              )}{" "}
              Try signing in — if your email still needs verification, we'll send a
              fresh link.
            </p>
          ) : (
            <p className="text-sm text-muted-foreground">Verifying…</p>
          )}
          <p className="mt-6 text-center text-sm text-muted-foreground">
            <Link to="/login" className="hover:underline">
              Back to sign in
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
